import { render } from "./CheckoutFailure.vue?vue&type=template&id=64003873"
import script from "./CheckoutFailure.vue?vue&type=script&lang=js"
export * from "./CheckoutFailure.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__